import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Storefront from "@/pages/Storefront";
import Login from "@/pages/Login";
import Verify from "@/pages/Verify";
import Dashboard from "@/pages/Dashboard";
import Checkout from "@/pages/Checkout";
import PaymentResult from "@/pages/PaymentResult";
import SharePage from "@/pages/SharePage";
import EventPage from "@/pages/EventPage";
import MyDownloads from "@/pages/MyDownloads";
import AdminPanel from "@/pages/admin/AdminPanel";

function App() {
  return (
    <div className="App grain min-h-screen">
      <AuthProvider>
        <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Storefront />} />
            <Route path="/login" element={<Login />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/payment/success" element={<PaymentResult />} />
            <Route path="/payment/cancel" element={<PaymentResult />} />
            <Route path="/share/:mediaId/:linkId" element={<SharePage />} />
            <Route path="/event/:id" element={<EventPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute role="customer">
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/downloads"
              element={
                <ProtectedRoute role="customer">
                  <MyDownloads />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute role="admin">
                  <AdminPanel />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        </CartProvider>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
